export default {
  SET_CURRENT_CONTRACT (state, currentContractData) {
    state.currentContract = currentContractData
  }
}
